import React, { useContext } from 'react';
import { ViewDbSettingsContext } from './Kalender/Components/SchedulerComponent/ViewDbSettingsContext';
import EDBox from '../../../../BaseComponents/EDBox/EDBox';
import EDListItemText from '../../../../BaseComponents/List/Components/EDListItemText';
import { ICustomBottomToolbarProps } from '../../_Common/Const/Delsystem';

export const KalenderToolbarResourceList: React.FunctionComponent<
  React.PropsWithChildren<ICustomBottomToolbarProps>
> = ({ sideMenuOpen }) => {
  const resourceContext = useContext(ViewDbSettingsContext);

  return (
    <div>
      <EDBox marginBottom={'16px'}>
        {sideMenuOpen ? (
          resourceContext?.resources?.length ?? 0 > 0 ? (
            resourceContext?.resources?.map((resource, index) => (
              <EDBox
                key={index}
                paddingTop={'10px'}
                paddingLeft={'10px'}
                paddingRight={'16px'}
              >
                <EDListItemText
                  primaryTypographyProps={{
                    sx: { color: resource.kanBoka ? undefined : 'red' },
                  }}
                >
                  {resource.resName} {'(' + resource.BO_RESURS_ID + ')'}
                </EDListItemText>
              </EDBox>
            ))
          ) : resourceContext.loggedInUserResource ? (
            <EDBox
              paddingTop={'10px'}
              paddingLeft={'10px'}
              paddingRight={'16px'}
            >
              <EDListItemText
                primaryTypographyProps={{
                  sx: {
                    color: resourceContext.loggedInUserResource.kanBoka
                      ? undefined
                      : 'red',
                  },
                }}
              >
                {resourceContext.loggedInUserResource.resName}{' '}
                {'(' + resourceContext.loggedInUserResource.BO_RESURS_ID + ')'}
              </EDListItemText>
            </EDBox>
          ) : undefined
        ) : undefined}
      </EDBox>
    </div>
  );
};
